import { Subject } from 'rxjs';
import { superagent } from '../../shared/superagent/superagent';
import singletons from '../../shared/singletons'

import { Observable } from 'rxjs';

class AddressesService {
  constructor() {
    this.data = {}
    this.subject = new Subject()
  }

  create(item) {

  }

  remove(item_id) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent
        .delete(`/api/addresses/${ item_id }`)
        .end((err, res)=> {
          singletons['loading'].stop()
          obs.next(res.body)
          obs.complete()
        })
      }
    )
  }

  update(item) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent
        .put(`/api/addresses/${ item.id }`)
        .send({address: item})
        .end((err, res)=> {
          singletons['loading'].stop()
          obs.next(res.body)
          obs.complete()
        })
    })
  }

  create(item) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent
        .post(`/api/addresses`)
        .send({address: item})
        .end((err, res)=> {
          singletons['loading'].stop()
          obs.next(res.body)
          obs.complete()
        })
    })
  }


}

let cd = new AddressesService()


export default cd;



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/addresses/address.model.js